module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('app-snackbar', {
    attrs: {
      "text": _vm.snackBarText,
      "show": _vm.snackbar,
      "color": _vm.snackbarColor,
      "timeOut": _vm.timeOut
    },
    on: {
      "update:show": function($event) {
        _vm.snackbar = $event
      }
    }
  }), _vm._v(" "), _c('coming-soon-modal', {
    attrs: {
      "dialog": _vm.dialog
    },
    on: {
      "update:dialog": function($event) {
        _vm.dialog = $event
      }
    }
  }), _vm._v(" "), _c('v-container', {
    staticClass: "signin"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-container', [_c('p', {
    staticClass: "text-title"
  }, [_vm._v("Ingresá con tus datos de acceso")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSignin.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-email",
    attrs: {
      "prepend-inner-icon": "mail",
      "name": "email",
      "label": "Email",
      "id": "email",
      "type": "email",
      "color": "#0098E1",
      "rules": _vm.$ponceConfig.emailRules,
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-password",
    attrs: {
      "prepend-inner-icon": "lock",
      "name": "password",
      "label": "Contraseña",
      "id": "password",
      "type": "password",
      "color": "#0098E1",
      "rules": _vm.$ponceConfig.passwordRules,
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center div-reset-password"
  }, [_c('a', {
    staticClass: "text-reset-password",
    on: {
      "click": _vm.comingsoon
    }
  }, [_c('u', [_vm._v("¿Olvidaste tu contraseña?")])])]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding-top": "30px"
    },
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    staticStyle: {
      "text-transform": "none",
      "font-family": "Source Sans Pro",
      "font-style": "normal",
      "font-weight": "550",
      "font-size": "16px",
      "line-height": "20px"
    },
    attrs: {
      "block": "",
      "color": "info",
      "type": "submit"
    }
  }, [_vm._v("\n                  Ingresar")])], 1)])], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50d0bac0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Signin.vue
// module id = 771
// module chunks = 14